import { DragDropContext, Droppable } from "@hello-pangea/dnd";
import { RandomId, StringHelper } from "@swivl-mono/helpers";
import { warn } from "@swivl-mono/helpers";
import { NodeInterface } from "@swivl-mono/types";
import { Select, SelectItem } from "@swivl-mono/ui";
import _ from "lodash";

import UserVariablesDropdown from "../../../../Components/Dropdowns/UserVariablesDropdown/UserVariablesDropdown";
import VarsModel from "../../../../Models/Variables/VarsModel.Model";
import TabNodeLayoutData from "../NodeLayouts/TabNodeLayoutData";
import DelayComponent from "../SidePanel/Inspector/components/DelayComponent";
import InspectorButton from "../SidePanel/Inspector/components/InspectorButton";
import InspectorFooter from "../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "./NodePanel";

const MultiSelect = {
  Type: "multiSelect",
  Empty: function () {
    let node = {
      id: RandomId(6),
      type: MultiSelect.Type,
      title: "Multi Select",
      saveType: "csv",
      csvSaveTo: null,
      onCompleteGoto: null,
      delay: 0.5,
      actions: [
        { id: RandomId(6), text: "A", saveToKey: null, saveToValue: null, goto: null },
        { id: RandomId(6), text: "B", saveToKey: null, saveToValue: null, goto: null }
      ]
    };

    return node;
  },

  PlumbData: function (node: NodeInterface) {
    const actionText = node.actions.map((action) => action.text);

    let title = "";
    if (node.saveType === "csv") {
      const variable = node.csvSaveTo && node.csvSaveTo.length ? "#*" + node.csvSaveTo + "*#" : "Unset";
      title = StringHelper.trimStringToLengthWithElipsis(VarsModel.replaceVariableNameInString(variable), 15);
    } else {
      title = "Save to Variables";
    }
    return TabNodeLayoutData({
      node: node,
      label: "Multi-Select",
      title: title,
      body: actionText.join("\n"),
      bodyHeight: actionText.length * 19,
      baseWidth: 150,

      tabs: [{ id: "onCompleteGoto", source: "onCompleteGoto", target: node.onCompleteGoto }]
    });
  },

  InspectorPanel: class ButtonsInspectorPanel extends NodePanel {
    constructor(props: any) {
      super(props);

      this.addButton = this.addButton.bind(this);
      this.onDragEnd = this.onDragEnd.bind(this);
    }

    addButton() {
      let buttonData = { id: RandomId(6), text: "New Option", saveToKey: null, saveToValue: null, goto: null };
      this.addItemToArray(buttonData, "actions", true);
    }

    onDragEnd = (e: any) => {
      if (!e.destination || !e.source || !e.destination.droppableId || !e.source.droppableId || !e.draggableId) {
        warn("Missing Params");
        return;
      }

      var oldOrder = this.props.node.actions;
      if (e.destination.index >= oldOrder.length) {
        var k = e.destination.index - oldOrder.length + 1;
        while (k--) {
          oldOrder.push(undefined);
        }
      }
      oldOrder.splice(e.destination.index, 0, oldOrder.splice(e.source.index, 1)[0]);
      let node = JSON.parse(JSON.stringify(this.props.node));
      _.set(node, "actions", oldOrder);
      this.props.updateNode(node, this.props.node, true);
      return;
    };

    renderCSV() {}

    render() {
      // return <div>HI MOM</div>;

      const node = this.props.node;

      let buttonViews;

      const csvVarDropdown =
        node.saveType !== "csv" ? null : (
          <>
            <label>Save to Variable</label>
            <UserVariablesDropdown onChange={this.onChange} skipUserId={true} name="csvSaveTo" value={this.props.node.csvSaveTo} />{" "}
          </>
        );

      var actions = this.props.node.actions.map((item, index) => {
        if (node.saveType === "variables") {
          return (
            <InspectorButton
              key={item.id}
              button={item}
              buttons={this.props.node.actions}
              arrayName="actions"
              arrayIndex={index}
              onChange={this.onChange}
              deleteValue={this.deleteValue}
              moveItemInArray={this.moveItemInArray}
              showVariables={true}
            />
          );
        }

        return (
          <InspectorButton
            key={item.id}
            button={item}
            buttons={this.props.node.actions}
            arrayName="actions"
            arrayIndex={index}
            onChange={this.onChange}
            deleteValue={this.deleteValue}
            moveItemInArray={this.moveItemInArray}
          />
        );
      });

      if (this.props.node.actions) {
        buttonViews = (
          <Droppable droppableId={"droppable_" + this.props.node.id} type="BUTTON">
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                style={{ backgroundColor: snapshot.isDraggingOver ? "#C3BCB9" : "transparent", borderRadius: 25 }}
                {...provided.droppableProps}
              >
                {provided.placeholder}
                {actions}
              </div>
            )}
          </Droppable>
        );
      }

      var options = [
        { value: "csv", id: "csv", label: "CSV", key: "0" },
        { value: "variables", id: "variables", label: "Variables", key: "1" }
      ];

      return (
        <DragDropContext onDragEnd={this.onDragEnd}>
          <div>
            <div className="panel button_panel">
              <InspectorNodeHeader title="Multi-Select" />
              <DelayComponent node={this.props.node} onChange={this.onChange} />
              <Select
                label="Save As"
                options={options as SelectItem[]}
                selectedValues={[node.saveType || "csv"]}
                hideClear
                onChange={(vals) => this.onChangeSwitch("saveType", vals[0])}
              />

              {csvVarDropdown}
              <label>Options</label>
              {buttonViews}
              <div className="addElementButton" onClick={this.addButton}>
                + ADD BUTTON
              </div>
              <div className="carouselPadding">.</div>
            </div>
            <InspectorFooter
              deleteNode={this.deleteNode}
              node={this.props.node}
              duplicateNode={this.props.duplicateNode}
              canDuplicate={this.props.canDuplicate}
            />
          </div>
        </DragDropContext>
      );
    }
  }
};
export default MultiSelect;
